import React from 'react';

// Components
import Tooltip from './Tooltip';

// Libraries
import classNames from 'classnames';

type Props = {
  message: string;
  title?: string;
  list?: Array<any>;
  place?: 'bottom' | 'top' | 'left' | 'right';
  children?: React.ReactNode;
  className?: string;
};

const LegacyWarningTooltip = ({ children, className, ...rest }: Props) => (
  <Tooltip className={classNames('legacy-warning-tooltip tooltip-icon', className)} icon="icon-warning" {...rest}>
    <span tabIndex={0}>{children || <i className="icon-warning displayed-icon" />}</span>
  </Tooltip>
);

export default LegacyWarningTooltip;
